import "./App.css";
import { LazyMotion, domAnimation } from "framer-motion";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import CompanyLanding from "./Pages/CompanyLanding";
import Portfolio from "./Pages/Portfolio";

function App() {
  return (
    <LazyMotion features={domAnimation}>
      <BrowserRouter>
        <Routes>

          <Route path="/" element={<CompanyLanding />} />


          <Route path="/our-portfolio" element={<Portfolio />} />

        </Routes>
      </BrowserRouter>
    </LazyMotion>
  );
}

export default App;